function formatMoney(amount: number) {
  return `$${amount}`
}

export {formatMoney}
